var TextColor = {
	text: "Text",
	background: "Background",
	textColor: "Text color",
	backgroundColor: "Background color"
};
var _en = {
	TextColor: TextColor
};

export { TextColor, _en as default };
